import ReactRenderer from "modules/_react-renderer";

ReactRenderer.render();